var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslate } from 'react-admin';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DefaultDialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import isEmpty from 'lodash/isEmpty';
import { useAuthenticationConfiguration } from '../useAuthenticationConfiguration';
export const TermsDialog = ({ open, onClose }) => {
    const translate = useTranslate();
    const { termsOfUse } = useAuthenticationConfiguration();
    return (React.createElement(Dialog, { "aria-labelledby": "terms_of_use_dialog_title", open: open, onClose: onClose, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, { id: "terms_of_use_dialog_title", onClose: onClose }, translate('apihub.account_setup.terms_of_use.terms_of_use_dialog.title')),
        React.createElement(DialogContent, { dividers: true },
            termsOfUse === null && React.createElement(LinearProgress, null),
            termsOfUse && React.createElement(TermsField, { content: termsOfUse })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { autoFocus: true, onClick: onClose, color: "primary" }, translate('apihub.account_setup.terms_of_use.terms_of_use_dialog.close')))));
};
const useTermsTitleStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}), {
    name: 'Layer7AccountSetupTermsTitle',
});
const DialogTitle = (_a) => {
    var { children, onClose } = _a, rest = __rest(_a, ["children", "onClose"]);
    const classes = useTermsTitleStyles(rest);
    const translate = useTranslate();
    return (React.createElement(DefaultDialogTitle, Object.assign({ disableTypography: true, className: classes.root }, rest),
        React.createElement(Typography, { variant: "h6" }, children),
        onClose ? (React.createElement(IconButton, { "aria-label": translate('apihub.account_setup.terms_of_use.terms_of_use_dialog.close'), className: classes.closeButton, onClick: onClose },
            React.createElement(Close, null))) : null));
};
const TermsField = ({ content }) => {
    return (React.createElement(React.Fragment, null, content.split('\\n').map((section, index) => isEmpty(section) ? (React.createElement("br", null)) : (React.createElement(Typography, { key: index, variant: "body2", paragraph: true }, section)))));
};
//# sourceMappingURL=TermsDialog.js.map